import _get from 'lodash/get';

export const getSubLessons = (lessonDetail) => {
  const lessons = _get(lessonDetail, 'lessons', []);
  return Array.isArray(lessons) ? lessons : [];
};

export const getNextSubLesson = (subLessons, selectedLessonNodeId) => {
  if (!Array.isArray(subLessons) || subLessons.length === 0) {
    return { currentIndex: 0, nextLesson: null };
  }

  const currentIndex = subLessons.findIndex(
    (lesson) => String(lesson.id) === String(selectedLessonNodeId),
  );
  const resolvedIndex = currentIndex >= 0 ? currentIndex : 0;
  const nextLesson =
    resolvedIndex < subLessons.length - 1 ? subLessons[resolvedIndex + 1] : null;

  return { currentIndex: resolvedIndex, nextLesson };
};
